import React from 'react';
import { LegalPageLayout, LegalSection } from 'components/LegalPageLayout';

// ==============================|| TERMS AND CONDITIONS ||============================== //

const TermsAndConditions = () => (
  <LegalPageLayout title="Terms and Conditions" lastUpdated="25 July 2026">
    <LegalSection title="1. Acceptance of Terms">
      By creating an account or using KiT (Keep In Touch), operated by Sterling Systems, you agree
      to be bound by these Terms and Conditions. If you do not agree with any part of these terms,
      please do not use the service.
    </LegalSection>

    <LegalSection title="2. Description of Service">
      KiT is a contact and relationship management platform that lets you organize contacts,
      groups, tasks, reminders, and related business information. Features and availability may
      vary by subscription plan and may change over time.
    </LegalSection>

    <LegalSection title="3. Accounts and Registration">
      You must provide accurate registration information, including a valid email address and
      mobile number, and keep your login credentials (including your password and, if enabled,
      your MPIN) confidential. You are responsible for all activity that occurs under your
      account. Notify us immediately if you suspect unauthorized access.
    </LegalSection>

    <LegalSection title="4. Subscription Plans, Dealers, and Billing">
      Certain features require a paid subscription plan. Fees, billing cycles, and applicable
      taxes (including GST, where applicable) will be presented at the time of purchase or
      renewal. Accounts referred through a dealer code are subject to the same terms as any other
      account. Fees are generally non-refundable except where required by law.
    </LegalSection>

    <LegalSection title="5. Acceptable Use">
      You agree not to use the service to send unsolicited or unlawful communications, upload
      content you do not have the right to use, attempt to gain unauthorized access to other
      accounts or systems, or otherwise misuse the platform. We reserve the right to suspend or
      terminate accounts that violate this section.
    </LegalSection>

    <LegalSection title="6. Your Data and Content">
      You retain ownership of the contacts, messages, and other content you upload. By using the
      service you grant us a limited license to store and process that content solely to provide
      the service to you. See our Privacy Policy for details on how we handle personal data.
    </LegalSection>

    <LegalSection title="7. Intellectual Property">
      The KiT name, logo, and underlying software are the property of Sterling Systems and may
      not be copied, modified, or redistributed without prior written permission.
    </LegalSection>

    <LegalSection title="8. Termination">
      You may stop using the service and close your account at any time. We may suspend or
      terminate accounts that violate these terms, with notice where reasonably possible.
    </LegalSection>

    <LegalSection title="9. Disclaimers and Limitation of Liability">
      The service is provided "as is" without warranties of any kind, express or implied. To the
      maximum extent permitted by law, Sterling Systems is not liable for indirect, incidental, or
      consequential damages arising from your use of the service.
    </LegalSection>

    <LegalSection title="10. Governing Law">
      These terms are governed by the laws of India, and any disputes will be subject to the
      exclusive jurisdiction of the courts of Maharashtra, India.
    </LegalSection>

    <LegalSection title="11. Changes to These Terms">
      We may update these terms from time to time. Material changes will be communicated via
      email or an in-app notice, and continued use of the service after changes take effect
      constitutes acceptance of the updated terms.
    </LegalSection>

    <LegalSection title="12. Contact Us">
      Questions about these terms can be sent to support@kitcontact.in.
    </LegalSection>
  </LegalPageLayout>
);

export default TermsAndConditions;
